import { Controller } from "@hotwired/stimulus"

const HEARTBEAT_MS = 15_000

// Reports visible time on page (and video plays) for a recipient visit.
// Sends the cumulative total each time, so duplicate or out-of-order
// pings can never inflate the duration — the server takes the max.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.activeMs = 0
    this.videoSent = false
    this.visibleSince = document.visibilityState === "visible" ? performance.now() : null
    this.onVisibility = () => this.handleVisibility()
    this.onPagehide = () => this.flush(true)
    document.addEventListener("visibilitychange", this.onVisibility)
    window.addEventListener("pagehide", this.onPagehide)
    this.timer = setInterval(() => this.flush(), HEARTBEAT_MS)
  }

  disconnect() {
    this.flush(true)
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisibility)
    window.removeEventListener("pagehide", this.onPagehide)
  }

  videoPlayed() {
    if (this.videoSent) return
    this.videoSent = true
    this.flush(false, { event: "video_play" })
  }

  handleVisibility() {
    if (document.visibilityState === "visible") {
      this.visibleSince = performance.now()
    } else {
      this.flush(true)
    }
  }

  snapshot() {
    if (this.visibleSince != null) {
      this.activeMs += performance.now() - this.visibleSince
      this.visibleSince = document.visibilityState === "visible" ? performance.now() : null
    }
  }

  flush(useBeacon = false, extra = {}) {
    if (!this.hasUrlValue) return

    this.snapshot()
    const body = new URLSearchParams({ seconds: Math.round(this.activeMs / 1000), ...extra })

    if (useBeacon && navigator.sendBeacon) {
      navigator.sendBeacon(this.urlValue, body)
    } else {
      fetch(this.urlValue, { method: "POST", body, keepalive: true }).catch(() => {})
    }
  }
}
